import { Button, Group } from '@mantine/core';
import GroupButton, { GroupButtonItem } from 'components/GroupButton';
import ModalPopupComponent from 'components/ModalPopup';
import React, { useCallback, useState } from 'react';
import MasterActivitySection from './MasterActivitySection';
import { IconUser, IconUsers } from '@tabler/icons-react';
import ExistingActivity from './ExistingActivity';

interface ModalAddActivityProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (_data: any) => void;
}
const options: GroupButtonItem[] = [
  {
    icon: IconUsers,
    title: 'Select Master Activity',
    subtitle: 'Select the activty from master activity menu',
    value: 'master'
  },
  {
    icon: IconUser,
    title: 'Select From Courses Activity',
    subtitle: 'Select the activity from existing courses',
    value: 'existing'
  }
];

const ModalAddActivity: React.FC<ModalAddActivityProps> = ({ opened, onClose, onSubmit }) => {
  const [selectedActivityType, setSelectedActivityType] = useState<string | number>('master');
  const [selectedActivity, setSelectedActivity] = useState<any[]>([]);

  const handleChange = (value: string | number) => {
    setSelectedActivityType(value);
  };

  const handleSubmit = useCallback(() => {
    onSubmit(selectedActivity);
  }, [selectedActivity, onSubmit]);

  return (
    <ModalPopupComponent title='Add Activity' size='xl' opened={opened} close={onClose}>
      <GroupButton
        onChange={handleChange}
        name='activity'
        defaultValue={selectedActivityType}
        options={options}
      />
      {selectedActivityType === 'master' && (
        <MasterActivitySection onChange={setSelectedActivity} />
      )}
      {selectedActivityType === 'existing' && <ExistingActivity onChange={setSelectedActivity} />}
      <Group justify='flex-end' mt={'md'}>
        <Button variant='outline' onClick={onClose}>
          Cancel
        </Button>
        <Button
          disabled={!selectedActivityType || selectedActivity.length === 0}
          onClick={handleSubmit}
        >
          Add Activity
        </Button>
      </Group>
    </ModalPopupComponent>
  );
};

export default ModalAddActivity;
